import React, { useEffect, useRef, useState } from "react";
import { Input } from "./Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import DropDown from "./DropDown.tsx";
import SmartSearchSelect from "./SmartSearchSelect";
import { province } from "sr/i18n/messages/setting";
import { Countries } from "sr/i18n/messages/setting";
import _ from "lodash";
import { useValidationErrorHandle } from "../functions/validationErrorHandle";
import { City } from "app/pages/component/types/city/City";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "app/pages/module/auth";
import { convertGeoJSONToLatLng } from "../functions/convertGeoJSONToLatLng ";
import { toast } from "react-toastify";
import { AppDispatch } from "sr/redux/store";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { fetchCompany } from "sr/redux/reducers/company";
import { fetchIndividual } from "sr/redux/reducers/individual";
import { LoadGoogleMaps } from "./LoadGoogleMap";
import { fetchCorporate } from "sr/redux/reducers/corporate";
import { renderRequiredLabel } from "sr/utils/helper";
import { RadioInput } from "./RadioInput";
import { getNearbyRegions } from "sr/utils/api/region/getNearbyRegions";
import { Checkbox } from "./CheckBox";
import CheckBoxHandle from "../functions/CheckBoxHandle";

declare const google: any;

export default function AutoLocation({
  showRegion = true,
  showMultiRegion = false,
  regions = [],
  setRegions = (value: any) => {},
  ...props
}) {
  const intl = useIntl();
  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  // const [formatedAddress, setFormatedAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [country, setCountry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [lat, setLat] = useState<any>("");
  const [lng, setLng] = useState<any>("");
  const [region, setRegion] = useState<string>("");
  const [regionId, setRegionId] = useState<string>("");
  const autoCompleteRef: any = useRef();
  const inputRef = useRef();
  const [loader, setLoader] = useState();
  const regionDataRef = useRef(null);
  const mapContainerRef = useRef(null);
  const zoom = 15;
  const { userType } = useAuth();
  const [regionRestrict, setRegionRestrict] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [userId, setUserId] = useState<string>("");
  const [customError, setCustomError] = useState<string>("");
  const [addNearRegion, setAddNearRegion] = useState(false);
  const [nearbyRegionsList, setNearbyRegionsList] = useState({
    isLoading: false,
    list: [],
  });
  const [allRegionsLoaded, setAllRegionsLoaded] = useState(false);

  const data = useSelector((state: any) => {
    if (userType === "cleaner") {
      return state.cleaner.data;
    }
    if (userType === "company") {
      return state.company.data;
    }
    if (userType === "individual") {
      return state.individual.data;
    }
    if (userType === "corporate") {
      return state.corporate.data;
    }
  });
  useEffect(() => {
    // AutoLocation data effect
  }, [data]);

  // useEffect(()=> {
  //   const fetchIP = async () => {
  //     const result = await getIp()
  //     setLat(result?.latitude)
  //     setLng(result?.longitude)
  //     setCountryCode(result?.country)
  //   }

  //   fetchIP()
  // },[])
  useEffect(() => {
    if (!data) {
      if (userId) {
        if (userType === "cleaner") {
          dispatch(fetchcleaner({ id: userId }));
        }
        if (userType === "company") {
          dispatch(fetchCompany({ id: userId }));
        }
        if (userType === "individual") {
          dispatch(fetchIndividual({ id: userId }));
        }
        if (userType === "corporate") {
          dispatch(fetchCorporate({ id: userId }));
        }
      }
    }
  }, [userId]);
  useEffect(() => {
    if (props?.NoregionFetch) {
      return;
    }
    if (data?.regionId?.city && props?.NoregionFetch !== true) {
      if (props?.restrictregionchange !== false) {
        setRegionRestrict(true);
      }
      regionDataRef.current = data?.regionId;
      setRegion(data?.regionId?.city);
      setRegionId(data?.regionId?.id);
      // Setting region data from user data
    }
  }, [data?.regionId?.city, props?.NoregionFetch, regionId]);
  const validationErrorHandle = useValidationErrorHandle();
  useEffect(() => {
    // if(!props?.address?.lat && !props?.address?.lng) {
    //   getCurrentLocation()
    // }
  }, []);
  useEffect(() => {
    if (props?.address && Object.keys(props?.address).length > 0) {
      setAddressLine1(props?.address?.address_line_1);
      setAddressLine2(props?.address?.address_line_2);
      setCity(props?.address?.city);
      setState(props?.address?.state);
      setZipCode(props?.address?.postal);
      setCountry(props?.address?.country || "");
      setLat(props?.address?.lat);
      setLng(props?.address?.lng);
      if (props?.address?.regionId) {
        setRegionId(props?.address?.regionId);
      }
    }
  }, [props?.address]);

  useEffect(() => {
    console.log(regionId);
  }, [regionId]);

  let mapObject: any;
  useEffect(() => {
    LoadGoogleMaps()
      .then((google: any) => {
        if (autoCompleteRef && mapContainerRef.current && google.maps) {
          // ✅ Initialize Autocomplete
          const options = {
            fields: [
              "address_components",
              "geometry",
              "icon",
              "name",
              "formatted_address",
            ],
            componentRestrictions: { country: ["us"] },
          };

          autoCompleteRef.current = new google.maps.places.Autocomplete(
            inputRef.current,
            options,
          );

          autoCompleteRef.current.addListener("place_changed", fillInAddress);

          // ✅ Initialize Map
          const mapProp = {
            center: { lat, lng },
            zoom,
          };
          mapObject = new google.maps.Map(
            document.getElementById("googleMap"),
            mapProp,
          );

          // ✅ Render initial marker
          renderMarker(lat, lng);
        }
      })
      .catch((err) => {
        // console.error("Google Maps JavaScript API failed to load:", err);
      });
  }, [lat, lng]);
  const fillInAddress = async () => {
    const place = autoCompleteRef.current.getPlace();
    if (!place || !place.geometry) {
      return;
    }

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    const geofence = regionDataRef?.current?.coordinates;
    const geofencelatlng = convertGeoJSONToLatLng(geofence);

    // const place = await autoCompleteRef?.current?.getPlace();
    const location = place?.geometry?.location;

    if (regionDataRef?.current) {
      const geofence = regionDataRef?.current?.coordinates;
      const geofencelatlng = convertGeoJSONToLatLng(geofence);

      if (
        !geofencelatlng ||
        !Array.isArray(geofencelatlng) ||
        geofencelatlng.length === 0
      ) {
        return;
      }

      const point = new google.maps.LatLng(location?.lat(), location?.lng());
      const polygon = new google.maps.Polygon({
        paths: geofencelatlng,
      });
      const isInsideRegionCheck = google.maps.geometry.poly.containsLocation(
        point,
        polygon,
      );
      const isInsideRegion = google.maps.geometry.poly.containsLocation(
        point,
        polygon,
      );

      if (isInsideRegionCheck) {
        if (place) {
          constructAddress(place);
        }
      } else {
        setAddressLine1("");
        setAddressLine2("");
        setCity("");
        setState("");
        setZipCode("");
        setCountry("");
        setLat("");
        setLng("");
        toast.error("Selected location is outside the Region", {
          toastId: "outside-region",
        });
        return;
      }
    } else {
      if (place) {
        constructAddress(place);
      }
    }
  };

  const constructAddress = (place: any) => {
    let address1 = "";
    const address2 = "";
    let postcode = "";
    let city = "";
    let state = "";
    let country = "";
    let cityShort = "";
    let countryShort = "";
    let stateLong = "";
    // setAddressLine1(place?.formatted_address);
    if (props?.componenttype !== "individualJob") {
      address1 = place?.name;
      // if(!address1) {
      //   address1 = place?.formatted_address;
      // }
    }
    for (const component of place?.address_components) {
      const componentTypes = component?.types;
      switch (true) {
        // case _.includes(componentTypes, 'street_number'): {
        //   address1 = `${component?.long_name} ${address1}`;
        //   break;
        // }
        // case _.includes(componentTypes, 'premise'): {
        //   address1 = `${address1} ${component?.long_name}`;
        //   break;
        // }
        // case _.includes(componentTypes, 'neighborhood'): {
        //   address1 = `${address1} ${component?.long_name}`;
        //   break;
        // }
        // case _.includes(componentTypes, 'route'): {
        //   address2 = `${component?.long_name} ${address2}`;
        //   break;
        // }
        // case _.includes(componentTypes, 'sublocality_level_1'):
        // case _.includes(componentTypes, 'sublocality'):
        // case _.includes(componentTypes, 'subpremise'): {
        //   address2 = `${address2} ${component?.long_name}`;
        //   break;
        // }
        case _.includes(componentTypes, "postal_code"): {
          postcode = `${component?.long_name}${postcode}`;
          break;
        }
        // case _.includes(componentTypes, 'postal_code_suffix'): {
        //   postcode = `${postcode}-${component?.long_name}`;
        //   break;
        // }
        case _.includes(componentTypes, "locality"): {
          city = component?.long_name;
          cityShort = component?.short_name;
          break;
        }
        case _.includes(componentTypes, "administrative_area_level_1"): {
          state = component?.short_name;
          stateLong = component?.long_name;
          break;
        }
        case _.includes(componentTypes, "country"): {
          country = component?.short_name;
          countryShort = component?.short_name;
          break;
        }
      }
    }

    if (props?.componenttype !== "individualJob") {
      if (!address1) {
        let addressArray = place?.formatted_address
          ?.split(",")
          ?.filter((item) => _.trim(item));

        if (addressArray?.length > 0) {
          addressArray = addressArray.filter((item) => {
            return !_.includes(
              [
                city,
                cityShort,
                state,
                stateLong,
                country,
                countryShort,
                postcode,
              ],
              _.trim(item),
            );
          });
          address1 = addressArray?.toString().replaceAll(",", ", ");
        }
      }
    }
    if (props?.componenttype === "individualJob") {
      const get = (type) =>
        place.address_components.find((c) => c.types.includes(type))
          ?.long_name || "";

      const fullAddress = [
        get("street_number"),
        get("route"),
        get("locality"), // City
        get("administrative_area_level_1"), // State full name
        get("postal_code"),
        get("country"),
      ]
        .filter(Boolean)
        .join(", ");
      address1 = fullAddress;
    }

    setAddressLine1(_.trim(address1));
    setAddressLine2(_.trim(address2));
    setCity(city);
    setState(state);
    setZipCode(postcode);
    setCountry(country);
    setLat(place.geometry.location.lat());
    setLng(place.geometry.location.lng());
    renderMarker(place.geometry.location.lat(), place.geometry.location.lng());
  };

  const renderMarker = (latitude: any, longitude: any) => {
    if (
      typeof window !== "undefined" &&
      typeof google !== "undefined" &&
      google.maps &&
      mapContainerRef.current
    ) {
      const myLatLng = { lat: latitude, lng: longitude };
      const mapProp = {
        center: myLatLng,
        zoom: 15,
      };
      mapObject = new google.maps.Map(
        document.getElementById("googleMap"),
        mapProp,
      );

      const marker = new google.maps.Marker({
        position: myLatLng,
        animation: google.maps.Animation.BOUNCE,
      });
      if (mapObject) {
        marker.setMap(mapObject);
      }
    }
  };

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setLat(position.coords.latitude);
        setLng(position.coords.longitude);
        renderMarker(position.coords.latitude, position.coords.longitude);
        getAddressFromLatLng(
          position.coords.latitude,
          position.coords.longitude,
        );
      },
      function (error) {
        // console.error("Error Code = " + error.code + " - " + error.message);
      },
    );
  };

  const getAddressFromLatLng = (lat: any, lng: any) => {
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_MAP_KEY}`,
    )
      .then((responseData) => {
        return responseData.json();
      })
      .then((placeData) => {
        constructAddress(placeData.results[0]);
      })
      .catch((error) => {});
  };

  const address = {
    address_line_1: addressline1,
    address_line_2: addressline2,
    city: city,
    state: state,
    country: country,
    postal: zipCode,
    lat: lat,
    lng: lng,
    regionId: regionId,
  };
  useEffect(() => {
    props?.HandleAutoLocation && props?.HandleAutoLocation(address);
  }, [
    addressline1,
    addressline2,
    city,
    state,
    countryCode,
    country,
    zipCode,
    lat,
    lng,
    region,
    regionId,
  ]);

  const handleSearchChange = (event) => {
    event.preventDefault();
    const value = event.currentTarget.value;
    setAddressLine1(value);
    if (!value) {
      setAddressLine1("");
      setAddressLine2("");
      setCity("");
      setState("");
      setZipCode("");
      setCountry("");
      setLat("");
      setLng("");
    }
  };

  const loadgetNearbyRegions = async (limit = 10) => {
    console.log("address", address);
    console.log("regionId", regionId);
    setNearbyRegionsList({ ...nearbyRegionsList, isLoading: true });
    setTimeout(async () => {
      const getNearbyRegionsResult = await getNearbyRegions({
        ids: [regionId],
        limit: limit,
      });
      console.log("getNearbyRegionsResult", getNearbyRegionsResult);
      const list = getNearbyRegionsResult?.data || [];

      setNearbyRegionsList({
        isLoading: false,
        list: list,
      });

      // Once we've asked for the "View All" ceiling, there's nothing more
      // to fetch — hide/disable regardless of count returned.
      setAllRegionsLoaded(limit >= 50 || list.length < limit);
    }, 100);
  };

  const isHideLatLang = _.get(props, "isHideLatLang", false);
  let googleMapStyles: any = { height: "200px", width: "100%" };
  if (!lat && !lng) {
    googleMapStyles = { ...googleMapStyles, pointerEvents: "none" };
  }
  useEffect(() => {
    if (regionId != undefined) {
      setAddressLine1("");
      setAddressLine2("");
      setCity("");
      setState("");
      setZipCode("");
      setCountry("");
      setLat("");
      setLng("");
      setAddNearRegion(false);
      setAllRegionsLoaded(false);

      if (props.setOptNearbyRegions) {
        props.setOptNearbyRegions(false);
      }

      setRegions([]);

      props?.HandleAutoLocation &&
        props?.HandleAutoLocation({
          address_line_1: "",
          address_line_2: "",
          city: "",
          state: "",
          country: "",
          postal: "",
          lat: "",
          lng: "",
          regionId: "",
        });
      setNearbyRegionsList({
        ...nearbyRegionsList,
        isLoading: false,
        list: [],
      });
    }
  }, [regionId]);

  return (
    <div>
      <form>
        {!props?.noOther && showRegion === true && (
          <SmartSearchSelect
            disabled={props?.restrictregionchange || regionRestrict}
            onChange={(selectedItem: any) => {
              if (typeof selectedItem === "object" && selectedItem !== null) {
                // Full data returned
                setRegion(selectedItem?.city);
                setRegionId(selectedItem?.id);
                regionDataRef.current = selectedItem;
                // Region selected by user (full data)
              } else {
                // Only ID returned
                setRegionId(selectedItem);
                // Region selected by user (ID only)
              }
            }}
            error={props?.errors?.regionId || ""}
            label="Region"
            value={regionId}
            placeholder="Select Region"
            returnFullData={true}
            options={
              data?.regionId
                ? [data?.regionId]
                : props?.address?.regionId
                ? [props?.address?.regionId]
                : null
            }
          />
        )}
        <div
          ref={mapContainerRef}
          id="googleMap"
          className={`mt-5 ${!props?.noshowMap === true ? "show" : "hidden"}`}
          style={googleMapStyles}
        />
        {props?.locationNameInput || ""}
        <div className="mt-5">
          <label className="text-normal  text-sm">
            {props?.label ? (
              props?.label
            ) : (
              <FormattedMessage
                id="INPUT.ADDRESS1.TITLE"
                defaultMessage="Address 1"
              ></FormattedMessage>
            )}
          </label>
          <input
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            ref={inputRef}
            value={addressline1}
            placeholder={
              props?.placeholder
                ? props?.placeholder
                : intl.formatMessage({
                    id: "INPUT.ADDRESS1.PLACEHOLDER",
                    defaultMessage: "Enter Address 1",
                  })
            }
            className="block w-full md:px-4 sm:px-1 md:py-2 sm:py-1 mt-2 sm:text-sm md:text-md 
text-black placeholder:text-gray-400 bg-white border border-gray-border rounded-md
focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring focus:ring-opacity-40"
            type="text"
            onChange={handleSearchChange}
          ></input>
          {props.errors?.address_line_1 ? (
            <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
              {validationErrorHandle(props.errors?.address_line_1)}
            </p>
          ) : (
            ""
          )}
        </div>
        <button
          type="button"
          onClick={() => {
            getCurrentLocation();
          }}
          className="text-gray-900 mt-2"
        >
          <FontAwesomeIcon
            icon={faLocationArrow}
            className="mr-2 text-gray-900"
          />
          Use my current location
        </button>
        {!props?.noOther && (
          <>
            <Input
              label={intl.formatMessage({
                id: "INPUT.ADDRESS2.TITLE",
                defaultMessage: "Address 2",
              })}
              placeholder={intl.formatMessage({
                id: "INPUT.ADDRESS2.PLACEHOLDER",
                defaultMessage: "Enter Address 2",
              })}
              type="text"
              value={addressline2}
              onChange={(e) => setAddressLine2(e.target.value)}
            />
            <DropDown
              error={props?.errors?.country}
              label={intl.formatMessage({
                id: "INPUT.COUNTRY.TITLE",
                defaultMessage: "Country",
              })}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >
              <option value="">
                <FormattedMessage
                  id="ECOMMERCE.COMMON.DROPDOWN.DEFAULT.OPTION"
                  defaultMessage="Select an option"
                />
              </option>
              {Countries.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </DropDown>
            <DropDown
              error={props?.errors?.state}
              label={intl.formatMessage({
                id: "INPUT.STATE.TITLE",
                defaultMessage: "Enter State",
              })}
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              <option value="">
                <FormattedMessage
                  id="ECOMMERCE.COMMON.DROPDOWN.DEFAULT.OPTION"
                  defaultMessage="Select an option"
                />
              </option>
              {province.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </DropDown>
            <Input
              error={props?.errors?.city}
              label={intl.formatMessage({
                id: "INPUT.CITY.TITLE",
                defaultMessage: "City",
              })}
              placeholder={intl.formatMessage({
                id: "INPUT.CITY.PLACEHOLDER",
                defaultMessage: "Enter Locality",
              })}
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
            <Input
              error={props?.errors?.postal || customError}
              label={intl.formatMessage({
                id: "INPUT.ZIPCODE",
                defaultMessage: "Enter Zip Code",
              })}
              placeholder={intl.formatMessage({
                id: "INPUT.ZIPCODE",
                defaultMessage: "Enter Zip Code",
              })}
              type="text"
              value={zipCode}
              onChange={(e) => {
                if (e.target.value?.length > 9) {
                  setCustomError("INPUT.VALIDATION.ZIP.CODE.VALID");
                } else {
                  setZipCode(e.target.value);
                }
              }}
            />
            {!isHideLatLang && (
              <>
                <Input
                  label={intl.formatMessage({
                    id: "INPUT.LATITUDE.TITLE",
                    defaultMessage: "Enter Latitude",
                  })}
                  placeholder={intl.formatMessage({
                    id: "INPUT.LATITUDE.TITLE",
                    defaultMessage: "Enter Latitude",
                  })}
                  type="text"
                  value={lat}
                  onChange={(e) => setLat(e.target.value)}
                />
                <Input
                  label={intl.formatMessage({
                    id: "INPUT.LONGITUDE.TITLE",
                    defaultMessage: "Enter Longitude",
                  })}
                  placeholder={intl.formatMessage({
                    id: "INPUT.LONGITUDE.TITLE",
                    defaultMessage: "Enter Longitude",
                  })}
                  type="text"
                  value={lng}
                  onChange={(e) => setLng(e.target.value)}
                />
              </>
            )}
          </>
        )}

        {showRegion === true && showMultiRegion === true && (
          <div className="mt-5 flex flex-col gap-2">
            <div className="">
              <p className="mt-10 mb-1 text-gray-700 text-sm ">
                <FormattedMessage
                  id="AUTH.INPUT.NEARBYREGION.TITLE"
                  defaultMessage="Do you want to add a nearby region?"
                />
              </p>
              <div className="flex space-x-6">
                <RadioInput
                  name="Yes"
                  value={true}
                  label={
                    <FormattedMessage
                      id="AUTH.INPUT.NEARBYREGION.NOW"
                      defaultMessage="Now"
                    />
                  }
                  checked={addNearRegion}
                  onChange={async () => {
                    if (regionId) {
                      setAddNearRegion(true);
                      props.setOptNearbyRegions &&
                        props.setOptNearbyRegions(true);
                      await loadgetNearbyRegions();
                    } else {
                      setAddNearRegion(false);
                      props.setOptNearbyRegions &&
                        props.setOptNearbyRegions(true);
                      toast.error("Please select a region first");
                    }
                  }}
                />
                <RadioInput
                  name="No"
                  value={false}
                  label={
                    <FormattedMessage
                      id="AUTH.INPUT.NEARBYREGION.LATER"
                      defaultMessage="Do it later"
                    />
                  }
                  checked={addNearRegion === false}
                  onChange={() => {
                    setAddNearRegion(false);
                    props.setOptNearbyRegions &&
                      props.setOptNearbyRegions(false);
                    setRegions([]);
                  }}
                />
              </div>
            </div>
            {addNearRegion === true && (
              <div className="border border-gray-300 rounded-md p-4 bg-gray-50">
                <div className="max-h-40 grid grid-cols-2 gap-2 overflow-y-auto">
                  {nearbyRegionsList.isLoading == true ? (
                    <div className="flex items-center justify-center rounded-md px-2 py-1 col-span-3">
                      <span className="text-sm text-gray-700">Loading...</span>
                    </div>
                  ) : (
                    nearbyRegionsList.list?.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between rounded-md border border-gray-border px-2 py-1"
                      >
                        <Checkbox
                          labelClass="font-normal"
                          key={index}
                          checked={regions.includes(item.id)}
                          label={`${item?.city} (${item?.state}), ${item?.distanceMiles} mi`}
                          id={item.id}
                          // name={data.value}
                          value={item.id}
                          onChange={(e) =>
                            CheckBoxHandle(e, regions, setRegions)
                          }
                        />
                      </div>
                    ))
                  )}
                </div>
                <div className="mt-2 flex justify-center">
                  <button
                    type="button"
                    disabled={allRegionsLoaded}
                    onClick={async () => {
                      if (allRegionsLoaded) {
                        toast.info("You've already loaded all nearby regions");
                        return;
                      }
                      if (regionId) {
                        await loadgetNearbyRegions(50);
                      }
                    }}
                    className={`ring-1 rounded px-2 py-1 focus:outline-none focus:shadow-outline ${
                      allRegionsLoaded
                        ? "text-gray-400 ring-gray-300 cursor-not-allowed"
                        : "text-blue-500 hover:text-blue-700"
                    }`}
                  >
                    <FormattedMessage
                      id="AUTH.INPUT.NEARBYREGION.VIEWALL"
                      defaultMessage="View All"
                    />
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </form>
    </div>
  );
}
